module.exports = __webpack_public_path__ + "static/img/match-playtesters.10dc438.png";


//////////////////
// WEBPACK FOOTER
// ./LandingPageTemp/Assets/match-playtesters.png
// module id = SpdT
// module chunks = 1